var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMano(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "82px",
    height: "82px",
    viewBox: "0 0 82 82",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "round_car-restitution-yellow") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 40,
    cy: 40,
    r: 40
  }), /*#__PURE__*/React.createElement("circle", {
    id: "path-3",
    cx: 40,
    cy: 40,
    r: 40
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons-2021",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "round_car-restitution-yellow",
    transform: "translate(1.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval-5",
    stroke: "#000000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 40,
    cy: 40,
    r: 40
  })), /*#__PURE__*/React.createElement("g", {
    id: "colors/yellow-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "colors/yellow",
    mask: "url(#mask-2)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 80,
    height: 80
  }))), /*#__PURE__*/React.createElement("g", {
    id: "path-1-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3725491,35.1621287 C35.5490196,35.1621287 36.4313725,34.5730198 36.8235294,33.640264 C35.2058824,33.4929868 33.9803922,33.2966171 33.1960784,32.8547855 C33.0490196,32.0202145 33.4411764,31.3820132 34.2745097,31.4311056 C35.2058824,31.9220297 36.872549,32.0202145 39.6176471,32.0202145 C44.1764706,32.0202145 45.7941176,31.5292904 45.7941176,30.1547029 L45.7941176,28.5346535 C45.7941176,27.0618812 44.5196079,26.669142 39.6176471,26.669142 C35.0588236,26.669142 33.6372549,27.0127887 33.4411764,28.240099 C33.7352941,28.1910066 34.0784313,28.1419142 34.3725491,28.1419142 C34.8627451,28.1419142 35.3039216,28.1910066 35.6960784,28.3382838 C35.8431373,28.2891914 36.0392157,28.240099 36.2843137,28.240099 C37.1666666,28.240099 37.5098039,28.5837459 37.5098039,29.4183168 C37.5098039,30.2037953 37.0686274,30.5965347 36.2843137,30.5965347 C35.7941177,30.5965347 35.4509804,30.400165 35.3039216,30.0565181 C35.0588236,29.9092409 34.7156863,29.8601485 34.3725491,29.8601485 C32.7549019,29.8601485 31.7254902,30.9401816 31.7254902,32.5111386 C31.7254902,34.0820958 32.7549019,35.1621287 34.3725491,35.1621287 Z M38.5882353,33.6893564 C38.0980392,35.554868 36.4803921,36.880363 34.3725491,36.880363 C31.8235294,36.880363 30.009804,35.0148515 30.009804,32.5111386 C30.009804,30.989274 30.6470589,29.7619637 31.7254902,28.9764851 L31.7254902,28.5346535 C31.7254902,25.8345709 33.5392158,25 39.6176471,25 C45.6960784,25 47.509804,25.8345709 47.509804,28.5346535 L54.5196078,28.5346535 L54.5196078,30.1547029 L47.509804,30.1547029 C47.509804,32.7566006 45.4019608,33.6893564 39.6176471,33.6893564 L38.5882353,33.6893564 Z M24.127451,54.75 L23,53.5226898 L25.0588235,52.0008251 C27.4607843,50.184406 29.2254901,49.5462047 31.7254902,49.5462047 C35.1078432,49.5462047 39.0784314,51.1171617 43.2450981,51.3135313 L55.5980392,42.8205446 C56.0882353,42.4768977 56.2843138,42.2314357 56.2843138,41.8877887 C56.2843138,41.2495874 55.7941177,40.7095709 55.1568627,40.7095709 C54.8627451,40.7095709 54.6666666,40.7586633 54.2254902,41.0532178 L48.6862745,44.7842409 C48.2450981,45.8151816 47.2647059,46.4533829 45.8431372,46.4533829 L38.7352942,46.4533829 L38.7352942,44.7351485 L45.8431372,44.7351485 C46.6764705,44.7351485 47.1666666,44.3424092 47.1666666,43.6060231 C47.1666666,42.869637 46.6764705,42.4768977 45.8431372,42.4768977 L33.7352941,42.4768977 C29.3235295,42.4768977 28.1960784,42.8205446 25.7450981,44.7351485 L24.127451,46.0115512 L23,44.7842409 L24.617647,43.5078383 C27.4117647,41.2986798 29.0784313,40.8077558 33.7843138,40.8077558 L45.8431372,40.8077558 C47.2647059,40.8077558 48.3921569,41.5441419 48.7352941,42.7223598 L53.4901961,39.5804456 C54.0784314,39.1877063 54.5196078,39.0404291 55.1568627,39.0404291 C56.7254902,39.0404291 58,40.3168317 58,41.8877887 C58,42.869637 57.6078431,43.4096535 56.1862746,44.3915016 L44.0294118,52.9826732 C39.7156863,52.9826732 35.3529412,51.2153465 31.7254902,51.2153465 C29.4705882,51.2153465 28.245098,51.6571782 26.1862745,53.2281354 L24.127451,54.75 Z",
    id: "path-1",
    fill: "#000000",
    mask: "url(#mask-4)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMano);
export default __webpack_public_path__ + "static/media/mano.dfbd7b765ed971a1644691055437cc16.svg";
export { ForwardRef as ReactComponent };